import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_STATE_INIT_ACTION,
  FETCH_STATE_SUCCESS_ACTION,
  FETCH_STATE_FAIL_ACTION,
  ADD_DISTRICT_INIT_ACTION,
  ADD_DISTRICT_SUCCESS_ACTION,
  ADD_DISTRICT_FAIL_ACTION,
  FETCH_DISTRICT_INIT_ACTION,
  FETCH_DISTRICT_SUCCESS_ACTION,
  FETCH_DISTRICT_FAIL_ACTION,
  DELETE_DISTRICT_INIT_ACTION,
  DELETE_DISTRICT_SUCCESS_ACTION,
  DELETE_DISTRICT_FAIL_ACTION,
  FETCH_DISTRICT_SEARCH_INIT_ACTION,
  FETCH_DISTRICT_SEARCH_SUCCESS_ACTION,
  FETCH_DISTRICT_SEARCH_FAIL_ACTION,
  EDIT_DISTRICT_INIT_ACTION,
  EDIT_DISTRICT_SUCCESS_ACTION,
  EDIT_DISTRICT_FAIL_ACTION,
  FILTER_BY_STATE_INIT_ACTION,
  FILTER_BY_STATE_SUCCESS_ACTION,
  FILTER_BY_STATE_FAIL_ACTION

} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchState() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/state?limit=100`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_STATE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_STATE_FAIL_ACTION,
        error: err,
      });
    }
  }
}


function* addDistrict(value) {

  let geo = []
  geo.push(value.value.latitude, value.value.longitude)
  const token = localStorage.getItem("token");

  try {
        let data = {
          name: value.value.districtName,
          stateId: value.value.states,
          geo: geo
        };

        const res = yield fetch(`${appConfig.ip}/districts`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        });

        if (!res.ok) {
          let errJSON = {};
          try {
            errJSON = yield res.json();
          } catch {
            throw Object.assign(res, errJSON);
          }
        } else {
          const resJSON = yield res.json();
          
          yield put({
            type: FETCH_DISTRICT_INIT_ACTION,
          });

          yield toast.success("District added successfully", {
            autoClose: 3000,
          });

          yield put({
            type: ADD_DISTRICT_SUCCESS_ACTION,
            payload: resJSON,
          });
        }
    
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_DISTRICT_FAIL_ACTION,
        error: err,
      });
    }
  }
}


function* fetchDistrict(value) {
  
  let pageno = value.value === undefined ? 1 : value.value;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/districts?limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_DISTRICT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_DISTRICT_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* deleteDistrict(value) {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/districts/` + value.value.id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
        if(errJSON){
          yield toast.error("Delete not allowed", {
            autoClose: 3000,
          });
        }
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      yield put({
        type: FETCH_DISTRICT_INIT_ACTION,
      });
      yield toast.success("Deleted successfully", {
        autoClose: 3000,
      });
      const resJSON = yield res.json();
      yield put({
        type: DELETE_DISTRICT_SUCCESS_ACTION,
      });
    }
  } catch (err) {
   
    if (err.ok === false) {
      
      yield put({
        type: DELETE_DISTRICT_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* districtSearch(value) {
  
  let searchVal = value.value.searchDistrict

  const token = localStorage.getItem("token");


  try {
    const res = yield fetch(
      `${appConfig.ip}/districts?limit=10&page=` + value.value.Spage + '&search=' + searchVal,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_DISTRICT_SEARCH_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DISTRICT_SEARCH_FAIL_ACTION, error: err });
    } else {
    }
  }
}


function* editDistrict(value) {
 
  try {
    const geo = []
    geo.push(value.value.latitude, value.value.longitude)

    const id = value.value.id

    const token = localStorage.getItem("token");


      const DistrictValue = {
        name: value.value.districtName,
        stateId: value.value.stateId,
        geo: geo
      };
      const res = yield fetch(`${appConfig.ip}/districts/` + id, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(DistrictValue)

      });
      if (!res.ok) {
        let errJSON = {};
        try {
          errJSON = yield res.json();
        } catch { }
        throw Object.assign(res, errJSON);
      } else {
        const resJSON = yield res.json();

        yield put({
          type: FETCH_DISTRICT_INIT_ACTION,

        });

        yield toast.success('District updated successfully', {
          autoClose: 3000
        })

        yield put({
          type: EDIT_DISTRICT_SUCCESS_ACTION,
          payload: resJSON,
        });

      }

  } catch (err) {

    if (err.ok === false) {
      yield put({ type: EDIT_DISTRICT_FAIL_ACTION, error: err });
    } else {
    }
  }


}

function* fetchDistrictFilter(value) {
 
  // let pageno = value.value === undefined ? 1 : value.value;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/districts?limit=10&page=` +value.value.page + '&stateId=' +value.value.value ,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FILTER_BY_STATE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FILTER_BY_STATE_FAIL_ACTION,
        error: err,
      });
    }
  }
}


export function* DistrictActionWatcher() {
  yield takeEvery(FETCH_STATE_INIT_ACTION, fetchState);
  yield takeEvery(ADD_DISTRICT_INIT_ACTION, addDistrict);
  yield takeEvery(FETCH_DISTRICT_INIT_ACTION, fetchDistrict);
  yield takeEvery(DELETE_DISTRICT_INIT_ACTION, deleteDistrict);
  yield takeEvery(FETCH_DISTRICT_SEARCH_INIT_ACTION, districtSearch);
  yield takeEvery(EDIT_DISTRICT_INIT_ACTION, editDistrict);
  yield takeEvery(FILTER_BY_STATE_INIT_ACTION, fetchDistrictFilter);
}
